import React, { useState } from 'react';
import { Currency } from 'common/classes/currency';
import { BaseTable, ColumnProp } from 'common/components/table/base';
import { DEFAULT_PAGE_SIZE } from 'common/components/table/config';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { userAccountsWithBalanceRecipe } from 'common/state/accounts/recipes';
import {
  UserAccountsWithBalanceState,
  defaultUserAccountsWithBalanceState,
} from 'common/state/accounts/states';
import {
  AccountWithBalance,
  UserAccountsWithBalanceActions,
} from 'common/state/accounts/actions';
import { doGetUserAccountsWithBalance } from 'common/state/accounts/thunkActions';
import { mdiAppleIcloud } from '@mdi/js';
import { TableTitle } from 'common/components/tables';
import { useProducerWithThunks } from 'common/hooks/useProducer';

export const AccountsTable = () => {
  const [state, dispatch] = useProducerWithThunks<
    UserAccountsWithBalanceState,
    UserAccountsWithBalanceActions
  >(userAccountsWithBalanceRecipe, defaultUserAccountsWithBalanceState);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const columns = useMemo(
    (): ColumnProp<AccountWithBalance>[] => [
      { key: 'system', title: 'System' },
      { key: 'username', title: 'Username' },
      { key: 'currency', title: 'Currency' },
      {
        key: 'balance',
        title: 'Balance',
        valueFormatter: (row) =>
          new Currency(row.credit, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.credit, row.currency).toString({ symbol: false }),
      },
      {
        key: 'pl',
        title: 'P/L All Time',
        valueFormatter: (row) => new Currency(row.pl, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.pl, row.currency).toString({ symbol: false }),
      },
    ],
    []
  );

  useEffect(() => {
    dispatch(
      doGetUserAccountsWithBalance('self', {
        limit: pageSize,
        offset: pageSize * (pageNo - 1),
      })
    );
  }, [dispatch, pageNo, pageSize]);

  return (
    <>
      <TableTitle icon={mdiAppleIcloud} title="Accounts" />
      <BaseTable
        columns={columns}
        rows={state.accounts || []}
        csvName="Account"
        pagination={{
          count: state.count,
          pageNo,
          pageSize,
          setPageNo,
          setPageSize,
        }}
        isLoading={state.pending}
        error={state.error}
        isSortable={false}
      />
    </>
  );
};
